import { ScrollGallery } from '@sloyd/ui';
import { Wrapper } from './Community.style';

export type CommunityProps = {
  browseGallery: any[];
  isLoading: boolean;
  callbacks: {
    onOpen: (item: Json) => void;
    onChange: (item: Json) => void;
  };
};

export function Community(props: CommunityProps) {
  const { browseGallery, isLoading, callbacks } = props;

  return (
    <Wrapper className='Community-wrapper' data-testid='Community-wrapper'>
      <ScrollGallery
        isLoading={isLoading}
        items={browseGallery}
        onOpen={callbacks.onOpen}
        onChange={callbacks.onChange}
      />
    </Wrapper>
  );
}

export default Community;
